import ApiClient from "../api-client";
import IBasketApiClient from "../Basket/basket-api-client";
import { EnvType } from "../services";
import { AddItemToBasketRequest } from "../Types/add-item-to-basket-request";
import { AddItemsToBasketResponse } from "../Types/add-item-to-basket-response";
import { BasketStatus } from "../Types/basket-status";
import { CheckoutResponse } from "../Types/checkout-response";
import { GenericResponseStd } from "../Types/generic-response-std";
import { GetBasketCountersResponse } from "../Types/get-basket-counters-response";
import { GetBasketDeliveryIdentityProfilesResponse } from "../Types/get-basket-delivery-identity-profiles-response";
import { GetBasketItemComputeBundleMakerMetadataRequest } from "../Types/get-basket-item-compute-bundle-maker-metadata-request";
import { GetBasketItemComputeBundleMakerMetadataResponse } from "../Types/get-basket-item-compute-bundle-maker-metadata-response";
import { GetBasketQuickviewResponse } from "../Types/get-basket-quickview-response";
import { GetBasketResponse } from "../Types/get-basket-response";
import { ListFavoriteResponse } from "../Types/list-favorite-response";
import { LoadSavedBasketRequest } from "../Types/load-saved-basket-request";
import { OrderCheckoutRequest } from "../Types/order-checkout-request";
import { SaveCurrentBasketRequest } from "../Types/save-current-basket-request";
import { SetItemsDirectivesRequest } from "../Types/set-items-directives-request";
import { SetItemsOptionsRequest } from "../Types/set-items-options-request";
import BasketApiClient from "./basket-api-client";

export default class BasketService {
  basketApiClient: IBasketApiClient;

  constructor(envType: EnvType) {
    this.basketApiClient = new BasketApiClient(new ApiClient(envType), envType);
  }
  async GetBasket(): Promise<GetBasketResponse> {
    return await this.basketApiClient.GetBasket();
  }
  async GetPartialBasket(itemId: number): Promise<GetBasketResponse> {
    return await this.basketApiClient.GetPartialBasket(itemId);
  }
  async GetBasketByStep(step: BasketStatus): Promise<GetBasketResponse> {
    return await this.basketApiClient.GetBasketByStep(step);
  }
  async ClearBasket(): Promise<GenericResponseStd> {
    return await this.basketApiClient.ClearBasket();
  }
  async GetBasketQuickView(): Promise<GetBasketQuickviewResponse> {
    return await this.basketApiClient.GetBasketQuickView();
  }
  async GetBasketCounters(): Promise<GetBasketCountersResponse> {
    return await this.basketApiClient.GetBasketCounters();
  }
  async AddPreconfiguredItemDCPReelsToBasket(request: AddItemToBasketRequest): Promise<GenericResponseStd> {
    return await this.basketApiClient.AddPreconfiguredItemDCPReelsToBasket(request);
  }
  async AddPreconfiguredItemDCPOVToBasket(request: AddItemToBasketRequest): Promise<GenericResponseStd> {
    return await this.basketApiClient.AddPreconfiguredItemDCPOVToBasket(request);
  }
  async AddItemToBasket(request: AddItemToBasketRequest): Promise<AddItemsToBasketResponse> {
    return await this.basketApiClient.AddItemToBasket(request);
  }
  async AddItemsToBasket(requests: AddItemToBasketRequest[]): Promise<AddItemsToBasketResponse> {
    return await this.basketApiClient.AddItemsToBasket(requests);
  }
  async RemoveItemFromBasket(itemId: number): Promise<GenericResponseStd> {
    return await this.basketApiClient.RemoveItemFromBasket(itemId);
  }
  async SetItemsDirectives(request: SetItemsDirectivesRequest): Promise<GenericResponseStd> {
    return await this.basketApiClient.SetItemsDirectives(request);
  }
  async SetItemsOptions(request: SetItemsOptionsRequest): Promise<GenericResponseStd> {
    return await this.basketApiClient.SetItemsOptions(request);
  }
  async DuplicateItem(itemId: number): Promise<GenericResponseStd> {
    return await this.basketApiClient.DuplicateItem(itemId);
  }
  async GetBasketItemComputeBundleMakerMetadata(
    request: GetBasketItemComputeBundleMakerMetadataRequest
  ): Promise<GetBasketItemComputeBundleMakerMetadataResponse> {
    return await this.basketApiClient.GetBasketItemComputeBundleMakerMetadata(request);
  }
  async Checkout(request: OrderCheckoutRequest): Promise<CheckoutResponse> {
    return await this.basketApiClient.Checkout(request);
  }
  async SaveCurrentBasket(request: SaveCurrentBasketRequest): Promise<GenericResponseStd> {
    return await this.basketApiClient.SaveCurrentBasket(request);
  }
  async LoadSavedBasket(request: LoadSavedBasketRequest): Promise<GenericResponseStd> {
    return await this.basketApiClient.LoadSavedBasket(request);
  }
  async ListSavedBaskets(): Promise<ListFavoriteResponse> {
    return await this.basketApiClient.ListSavedBaskets();
  }
  async DeleteSavedBasket(id: number): Promise<GenericResponseStd> {
    return await this.basketApiClient.DeleteSavedBasket(id);
  }
  async GetBasketDeliveryIdentityProfiles(): Promise<GetBasketDeliveryIdentityProfilesResponse> {
    return await this.basketApiClient.GetBasketDeliveryIdentityProfiles();
  }
  async GetItemDeliveryIdentityProfile(itemId: number): Promise<GetBasketDeliveryIdentityProfilesResponse> {
    return await this.basketApiClient.GetItemDeliveryIdentityProfile(itemId);
  }
  //------Utils------
  GetServiceUrl(): string {
    return this.basketApiClient.GetApiUrl();
  }
}
